import apiRequest from './client';

// CRUD des superviseurs par la company (Parametres > Superviseurs).
export const listSupervisors = () => apiRequest('/supervisors/');

export const getSupervisor = (id) => apiRequest(`/supervisors/${id}/`);

export const createSupervisor = (data) =>
  apiRequest('/supervisors/', { method: 'POST', body: data });

export const updateSupervisor = (id, data) =>
  apiRequest(`/supervisors/${id}/`, { method: 'PATCH', body: data });

export const deleteSupervisor = (id) =>
  apiRequest(`/supervisors/${id}/`, { method: 'DELETE' });
